import { Observable } from 'rxjs';
import { ApiService, GET_GAME_BY_ID_PATH, GetGameByIdPathParams, GetGameByIdResponse } from '@core-http';

export class GamesService extends ApiService {
  getOneGame(pathParams: GetGameByIdPathParams): Observable<GetGameByIdResponse> {
    const path: string = this.fillPathParams(GET_GAME_BY_ID_PATH, pathParams);

    return this.httpClient.get<GetGameByIdResponse>(`${this.env.apiUrl}${path}`);
  }
}
